import React from "react";
import { slide as Menu } from "react-burger-menu";
import "./Sidebar.css";

const Sidebar = () => {
  return (
    <Menu>
   <div>
   <h1>About Play it!</h1>
   <text>
   Play it! is part of my examination project at EC utbildning
    where I study to become a Java developer. Coding in Java is fun, 
    but i also found an interest in React and this project is a way for me to learn to code in React. 
   This will be my work in progress where I will try to add more games and more features as time goes on and my skills improve.
   <br></br>
   <br></br>

   Emma Svensson Arnér
   </text>
   </div>
   </Menu>
  );
};

export default Sidebar;
